import dynamic from 'next/dynamic'
import React, { useState } from 'react'
import { createPortal } from 'react-dom'

interface Props {
  children: React.ReactNode
}

const Portal: React.FC<Props> = (props: Props) => {
  const [container] = useState(document.createElement('div'))
  document.body.appendChild(container)
  return createPortal(<section>{props.children}</section>, container || null)
}

export default dynamic(() => Promise.resolve(Portal), {
  ssr: false
})
